import { User } from "@auth0/auth0-spa-js";
import { createAppStore } from "../index";

export interface AuthState {
  user: User | null;
  token: string | null;
  setUser: (user: User | null) => void;
  setToken: (token: string) => void;
  clearAuth: () => void;
}

const useAuthStore = createAppStore<AuthState>(
  (set) => ({
    user: null,
    token: null,
    setUser: (user: User | null) =>
      set((state) => {
        state.user = user;
      }),
    setToken: (token: string) =>
      set((state) => {
        state.token = token;
      }),
    clearAuth: () =>
      set((state) => {
        state.user = null;
        state.token = null;
      }),
  }),
  "auth_store",
);

export default useAuthStore;
